import React from 'react';

const Loading = () => (
  <div className="loadmore">
    <div className="loading" />
  </div>
);

export default Loading;
